import * as En from '../translations/en.json';
import * as Sv from '../translations/sv.json';

export default function config($translateProvider) {
    $translateProvider.translations('en', En);
    $translateProvider.translations('sv', Sv);

    $translateProvider.preferredLanguage('sv');
}

/*@ngInject*/
config.$inject = ['$translateProvider'];
